import { ActionTypes, removeCollaboratorsFromOrganization } from 'store/data/collaborators';
import { Operation } from 'hooks/store/types';
import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';

type HandlerInput = Parameters<typeof removeCollaboratorsFromOrganization>[0];

export function useRemoveCollaboratorsFromOrganization(): Operation<
	(input: HandlerInput) => Promise<void>
> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(
		ActionTypes.REMOVE_COLLABORATORS_FROM_ORGANIZATIONS
	);

	async function handler(input: HandlerInput) {
		if (loading) return;
		if (error) resetError();

		await dispatch(removeCollaboratorsFromOrganization(input));
	}

	return [{ loading, error }, handler];
}
